import bulkAssignSupraLockboxForSingleUser from 'api/SupraLockboxController/bulkAssignSupraLockboxForSingleUser';
import bulkCreateShacklePermissions from 'api/SupraLockboxController/bulkCreateShacklePermissions';
import bulkUnassignSupraLockboxes from 'api/SupraLockboxController/bulkUnassignSupraLockboxes';

interface ConfirmationResult {
  successful: number;
  unsuccessful: number;
  successfulIds?: string[];
  failedIds?: string[];
  failedIdsWithErrors?: { id: string; errorMessage: string }[];
}

interface LockboxPermissionsPayload {
  mode: 'owner' | 'assignee' | 'shackle';
  assignMode: 'assign' | 'unassign';
  targetId: string;
  selectedIds: string[];
  selectedSerialNumbers?: string[];
  ownerOrAssigneeType: string;
  lockboxAssigneeMap?: Record<string, string>;
  grantOfficeShacklePermissions?: boolean;
}

export const handleLockboxPermissionsConfirm = async (
  payload: LockboxPermissionsPayload,
): Promise<ConfirmationResult> => {
  const {
    mode,
    assignMode,
    targetId,
    selectedIds,
    selectedSerialNumbers = [],
    ownerOrAssigneeType,
    lockboxAssigneeMap = {},
    grantOfficeShacklePermissions,
  } = payload;

  try {
    if (mode === 'shackle') {
      if (!targetId) {
        return { successful: 0, unsuccessful: selectedIds.length };
      }
      const result = await bulkCreateShacklePermissions({
        userId:
          ownerOrAssigneeType === 'office' ? targetId.split('-')[2] : targetId,
        lockboxIds: selectedIds,
        serialNumbers: selectedSerialNumbers,
        ownerOrAssigneeType: ownerOrAssigneeType as 'user' | 'office',
        grantOfficeShacklePermissions,
      });
      return {
        successful: result.successCount,
        unsuccessful: result.failureCount,
        successfulIds: result.successfulIds,
        failedIds: result.failedIds,
        failedIdsWithErrors: result.failedIdsWithErrors,
      };
    }
    if (mode === 'assignee' && assignMode === 'unassign') {
      if (Object.keys(lockboxAssigneeMap).length === 0) {
        return { successful: 0, unsuccessful: selectedIds.length };
      }

      const result = await bulkUnassignSupraLockboxes({
        lockboxAssigneeMap,
      });
      return {
        successful: result.successCount,
        unsuccessful: result.failureCount,
        successfulIds: result.successfulIds,
        failedIds: result.failedIds,
        failedIdsWithErrors: result.failedIdsWithErrors,
      };
    }
    if (mode === 'owner' || (mode === 'assignee' && assignMode === 'assign')) {
      if (!targetId) {
        return { successful: 0, unsuccessful: selectedIds.length };
      }
      const result = await bulkAssignSupraLockboxForSingleUser({
        userId:
          ownerOrAssigneeType === 'office' ? targetId.split('-')[2] : targetId,
        lockboxIds: selectedIds,
        permissions: {
          permissionType: mode as 'owner' | 'assignee',
          ownerOrAssigneeType: ownerOrAssigneeType as 'user' | 'office',
          branchIndex:
            ownerOrAssigneeType === 'office' ? targetId.split('-')[1] : null,
        },
        granteeUserIds: [],
        grantOfficeShacklePermissions,
      });
      return {
        successful: result.successCount,
        unsuccessful: result.failureCount,
        successfulIds: result.successfulIds,
        failedIds: result.failedIds,
        failedIdsWithErrors: result.failedIdsWithErrors,
      };
    }
    return { successful: 0, unsuccessful: selectedIds.length };
  } catch {
    return { successful: 0, unsuccessful: selectedIds.length };
  }
};
